import { render, staticRenderFns } from "./BcTimePicker.vue?vue&type=template&id=25c7233f"
import script from "./BcTimePicker.vue?vue&type=script&lang=js"
export * from "./BcTimePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports